<template>
  <b-modal
    id="modal-selecao-controles"
    size="lg"
    :title="$t('header.selecionar-controles')"
    centered
  >
    <SelecaoPeriodo
      :mostrarTurno="false"
      :mostrarVisualizacao="false"
      :relatorio_id="relatorioId"
      v-if="relatorioId"
    />
    <b-card
      bg-variant="light"
      :header="$t('header.selecionar-controles')"
      style="height: 100%"
      class="mt-2"
    >
      <b-row align-h="between" class="mb-2">
        <b-col cols="auto">
          <b-form-checkbox
            v-model="selectAllChecked"
            @change="toggleSelectAll"
            :indeterminate="isIndeterminate"
          >
            {{ $t("botoes.selecionar-todos") }}
          </b-form-checkbox>
          <small class="text-muted">
            Total Selecionados: {{ selected.length }}
            {{ $t("labels.controles") }}
          </small>
        </b-col>
        <b-col cols="auto">
          <small class="text-muted">
            Total: {{ totalControles }} {{ $t("labels.controles") }}
          </small>
        </b-col>
      </b-row>
      <b-table
        v-if="controles.length > 0"
        :items="controles"
        :fields="fields"
        select-mode="range"
        responsive="sm"
        ref="selectableTable"
        selectable
        bordered
        hover
        small
        center
        :current-page="currentPage"
        :per-page="perPage"
        class="table-controles text-center mt-2 table-wrapper"
        head-variant="light"
        @row-selected="onRowSelected"
      >
        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>

        <template v-slot:cell(excluir)="row">
          <b-icon
            icon="trash-fill"
            variant="danger"
            @click="excluir(row.item.cod)"
          ></b-icon>
        </template>
      </b-table>

      <b-row>
        <b-col>
          <b-form-group>
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            >
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <template #modal-footer>
      <b-button
        @click="adicinarControles"
        :disabled="selected.length == 0"
        v-if="!carregandoControles"
      >
        <b-icon icon="plus"></b-icon>
        {{ $t("botoes.adicionar") }}
      </b-button>
      <b-button
        variant="primary"
        class="float-right"
        v-if="carregandoControles"
        disabled
      >
        <b-icon icon="arrow-clockwise" animation="spin-pulse"></b-icon>
        {{ $t("botoes.carregando") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import SelecaoPeriodo from "@/components/SelecaoPeriodo.vue";

export default {
  name: "ModalSelecaoControles",
  components: {
    SelecaoPeriodo,
  },
  props: {
    controles: {
      type: Array,
      default: () => [],
    },
    relatorioId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      carregandoControles: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      fields: ["selected", { key: "controle_id", label: "cod" }, "data"],
      selected: [],
      selectAllChecked: false,
      pageOptions: [
        { value: 5, text: this.$t("paginacao.5-itens-por-pagina") },
        { value: 10, text: this.$t("paginacao.10-itens-por-pagina") },
        { value: 15, text: this.$t("paginacao.15-itens-por-pagina") },
        { value: 100, text: this.$t("paginacao.100-itens-por-pagina") },
      ],
    };
  },
  computed: {
    filter() {
      return (
        "?tipoPeriodo=" +
        this.$store.state.tipoPeriodo +
        "&ano=" +
        this.$store.state.ano +
        "&mes=" +
        this.$store.state.mes +
        "&semana=" +
        this.$store.state.semana +
        "&data=" +
        this.$store.state.data +
        "&turno=" +
        this.$store.state.turno
      );
    },
    totalControles() {
      return this.controles.length;
    },
    isIndeterminate() {
      return (
        this.selected.length > 0 && this.selected.length < this.controles.length
      );
    },
  },
  methods: {
    abrirModal() {
      this.$bvModal.show("modal-selecao-controles");
      this.carregarControles();
    },
    fecharModal() {
      this.$bvModal.hide("modal-selecao-controles");
    },
    carregarControles() {
      this.$emit("carregar-controles-iniciado");
      this.carregandoControles = true;

      this.$http
        .get("api/relatorio/controles/" + this.relatorioId + this.filter)
        .then((response) => {
          const controlesFormatados = [];
          response.data.forEach((controle) => {
            const d = new Date(controle.data).toLocaleDateString("pt-br");
            const h = new Date(controle.data).toLocaleTimeString("pt-br");
            controlesFormatados.push({
              ativo: controle.ativo ? true : false,
              controle_id: controle.id,
              data: d + " " + h,
            });
          });

          this.totalRows = controlesFormatados.length;
          this.$emit("controles-carregados", controlesFormatados);
          this.carregandoControles = false;
        })
        .catch((errors) => {
          this.$emit("erro-carregar-controles", errors.response);
          this.carregandoControles = false;
        });
    },
    adicinarControles() {
      this.$emit("adicionar-controles", this.selected);
      this.clearSelected();
      this.fecharModal();
    },
    onRowSelected(items) {
      this.selected = items;
      this.updateSelectAllCheckbox();
    },
    toggleSelectAll() {
      if (this.selectAllChecked) {
        this.selectAllControles();
      } else {
        this.clearSelected();
      }
    },
    selectAllControles() {
      // Seleciona todos os controles do array completo, não apenas da página atual
      // this.$refs.selectableTable.selectAllRows();
      this.selected = [...this.controles];
      this.selectAllChecked = true;
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
      this.selected = [];
      this.selectAllChecked = false;
    },
    updateSelectAllCheckbox() {
      if (this.selected.length === 0) {
        this.selectAllChecked = false;
      } else if (this.selected.length === this.controles.length) {
        this.selectAllChecked = true;
      }
    },
    excluir(cod) {
      this.$emit("excluir-controle", cod);
    },
  },
  watch: {
    controles: function () {
      this.totalRows = this.controles.length;
      this.updateSelectAllCheckbox();
    },
    filter: function () {
      if (this.relatorioId) {
        this.carregarControles();
      }
    },
  },
  mounted() {
    if (this.relatorioId) {
      this.carregarControles();
    }
  },
};
</script>

<style scoped>
.table-wrapper {
  font-size: 12px !important;
}
</style>
